var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[(_vm.data.video_url)?_c('video',{attrs:{"src":_vm.data.video_url,"controls":""}}):_vm._e(),_c('div',{staticClass:"ql-snow"},[_c('div',{staticClass:"article-content ql-editor",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }